<template>
    <table class="table is-fullwidth is-bordered">
        <thead>
            <tr>
                <th class="has-text-centered is-vcentered px-1">
                    {{ $t('Sessions.name') }}
                </th>
                <th class="has-text-centered is-vcentered px-1">
                    {{ $t('Sessions.short_owner') }}
                </th>
                <th class="has-text-centered is-vcentered px-1">
                    {{ $t('Sessions.code') }}
                </th>
                <!--<th>{{ $t('Sessions.type_game') }}</th>-->
                <th class="has-text-centered is-vcentered px-1">
                    {{ $t('Sessions.players_number') }}
                </th>
                <th class="has-text-centered is-vcentered px-1">
                    {{ $t('Sessions.last_played_date') }}
                </th>
                <th class="has-text-centered is-vcentered px-1">
                    {{ $t('Sessions.device') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="session in sessions" :key="session.id">
                <td class="subtitle is-7">
                    <router-link
                        :to="{
                            name: 'session-detail',
                            params: { _id: session._id },
                        }"
                        >{{ session.title }}</router-link
                    >
                </td>
                <td class="subtitle is-7 has-text-centered is-vcentered px-1">
                    {{ session.owner.username }}
                </td>
                <td class="subtitle is-7 has-text-centered is-vcentered px-1">
                    {{ session.shortCode }}
                </td>
                <!--<td class="subtitle is-6">{{ gameType(session) }}</td>-->
                <td class="subtitle is-7 has-text-centered is-vcentered px-1">
                    {{ session.participants ? session.participants.length : 0 }}
                </td>
                <td class="subtitle is-7 has-text-centered is-vcentered px-1">
                    {{ $options.filters.createdDate(session.created) }}
                </td>
                <td class="subtitle is-7 has-text-centered is-vcentered px-1">
                    {{ playType(session) }}
                </td>

                <!--td>
          <div 
            v-if="canPlay(session)" 
            class="buttons is-centered">
            <router-link
              :to="{
                name: 'play',
                query: { code: session.shortCode },
              }"
              class="button is-white"
            >
              <span class="icon is-small">
                <i class="fas fa-play"></i>
              </span>
            </router-link>
          </div>
          <p
            v-t="'Sessions.STATUS_COMPLETED'"
            v-else
            class="tag is-success"
          ></p>
                </td-->
            </tr>
        </tbody>
    </table>
</template>
<script>
import moment from 'moment';
export default {
    props: {
        sessions: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {},
    filters: {
        createdDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    methods: {
        canPlay(session) {
            return (
                session.allowsReset ||
                session.session_answers.length != session.context.length
            );
        },
        gameType(session) {
            if (session.project) {
                if (
                    session.project.type === 'trivial' &&
                    session.project.mode === 'map'
                ) {
                    return this.$t('Creation.trivialgeo.title');
                } else if (
                    session.project.type === 'trivial' &&
                    session.project.mode != 'map'
                ) {
                    return this.$t('Creation.trivial.title');
                } else {
                    return this.$t(
                        'Constants.SESSION_TYPE_' +
                            session.project.type.toUpperCase()
                    );
                }
            } else {
                if (session.configuration.mode == 'MAP') {
                    return this.$t('Creation.trivialgeo.title');
                } else if (session.configuration.mode == 'TRIVIAL') {
                    return this.$t('Creation.trivial.title');
                } else {
                    return this.$t(
                        'Constants.SESSION_TYPE_' +
                            session.configuration.mode.toUpperCase()
                    );
                }
            }
        },
        playType(session) {
            if (!session.configuration.app && !session.configuration.web) {
                return 'ALL';
            } else if (session.configuration.web) {
                return 'WEB';
            } else if (session.configuration.app) {
                return 'APP';
            }

            return 'ALL';
        },
    },
};
</script>

<style scoped></style>
